import { render, staticRenderFns } from "./OriginalRecord.vue?vue&type=template&id=a59e437e&scoped=true"
import script from "./OriginalRecord.vue?vue&type=script&lang=js"
export * from "./OriginalRecord.vue?vue&type=script&lang=js"
import style0 from "./OriginalRecord.vue?vue&type=style&index=0&id=a59e437e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59e437e",
  null
  
)

export default component.exports